import { BookCategory } from '../interfaces/book-category';

export const AVAILABILITY_LIST: BookCategory[] = [
    { categoryName: 'Partial', category: 'partial' },
    { categoryName: 'Full', category: 'full' },
    { categoryName: 'Free ebooks', category: 'free-ebooks' },
    { categoryName: 'Paid ebooks', category: 'paid-ebooks' },
    { categoryName: 'Ebooks', category: 'ebooks' },
];


export const TYPE_LIST: BookCategory[] = [
    { categoryName: 'Books & magazines', category: 'all' },
    { categoryName: 'Books', category: 'books' },
    { categoryName: 'Magazines', category: 'magazines' },
];


export const LANGUAGE_LIST: BookCategory[] = [
    { categoryName: 'Afrikaans', category: 'af' },
    { categoryName: 'Arabic', category: 'ar' },
    { categoryName: 'Armenian', category: 'hy' },
    { categoryName: 'Bulgarian', category: 'bg' },
    { categoryName: 'Catalan', category: 'ca' },
    { categoryName: 'Simplified Chinese', category: 'zh-CN' },
    { categoryName: 'Traditional Chinese', category: 'zh-TW' },
    { categoryName: 'Croatian', category: 'hr' },
    { categoryName: 'Czech', category: 'cs' },
    { categoryName: 'Danish', category: 'da' },
    { categoryName: 'Dutch', category: 'nl' },
    { categoryName: 'English', category: 'en' },
    { categoryName: 'Filipino', category: 'fil' },
    { categoryName: 'Finnish', category: 'fi' },
    { categoryName: 'French', category: 'fr' },
    { categoryName: 'German', category: 'de' },
    { categoryName: 'Greek', category: 'el' },
    { categoryName: 'Hebrew', category: 'he' },
    { categoryName: 'Hungarian', category: 'hu' },
    { categoryName: 'Icelandic', category: 'is' },
    { categoryName: 'Indonesian', category: 'id' },
    { categoryName: 'Italian', category: 'it' },
    { categoryName: 'Japanese', category: 'ja' },
    { categoryName: 'Korean', category: 'ko' },
    { categoryName: 'Latvian', category: 'lv' },
    { categoryName: 'Malay', category: 'ms' },
    { categoryName: 'Norwegian', category: 'no' },
    { categoryName: 'Polish', category: 'pl' },
    { categoryName: 'Portuguese (Brazil)', category: 'pt-BR' },
    { categoryName: 'Portuguese (Portugal)', category: 'pt-PT' },
    { categoryName: 'Romanian', category: 'ro' },
    { categoryName: 'Russian', category: 'ru' },
    { categoryName: 'Serbian ', category: 'sr' },
    { categoryName: 'Slovak', category: 'sk' },
    { categoryName: 'Slovenian', category: 'sl' },
    { categoryName: 'Spanish', category: 'es' },
    { categoryName: 'Swedish', category: 'sv' },
    { categoryName: 'Tagalog', category: 'tl' },
    { categoryName: 'Thai', category: 'th' },
    { categoryName: 'German', category: 'tr' },
    { categoryName: 'Turkish', category: 'uk' },
    { categoryName: 'Vietnamese', category: 'vi' },
];

  
export const CATEGORY_LIST: BookCategory[] = [
    { categoryName: 'ANTIQUES & COLLECTIBLES', category: 'antiques+collectibles' },
    { categoryName: 'ARCHITECTURE', category: 'architecture' },
    { categoryName: 'ART', category: 'art' },
    { categoryName: 'BIBLES', category: 'bibles' },
    { categoryName: 'BIOGRAPHY & AUTOBIOGRAPHY', category: 'biography+autobiography' },
    { categoryName: 'BODY, MIND & SPIRIT', category: 'body+mind+spirit' },
    { categoryName: 'BUSINESS & ECONOMICS', category: 'business+economics' },
    { categoryName: 'COMICS & GRAPHIC NOVELS', category: 'comics+graphic+novels' },
    { categoryName: 'COMPUTERS', category: 'computers' },
    { categoryName: 'COOKING', category: 'cooking' },
    { categoryName: 'CRAFTS & HOBBIES', category: 'craft+hobbies' },
    { categoryName: 'CRIME', category: 'rime' },
    { categoryName: 'DESIGN', category: 'design' },
    { categoryName: 'DRAMA', category: 'drama' },
    { categoryName: 'EDUCATION', category: 'education' },
    { categoryName: 'FAMILY & RELATIONSHIPS', category: 'family+relationships' },
    { categoryName: 'FICTION', category: 'fiction' },
    { categoryName: 'GAMES & ACTIVITIES', category: 'games+activities' },
    { categoryName: 'GARDENING', category: 'gardening' },
    { categoryName: 'HEALTH & FITNESS', category: 'health+fitness' },
    { categoryName: 'HISTORY', category: 'history' },
    { categoryName: 'HOUSE & HOME', category: 'house+home' },
    { categoryName: 'HUMOR', category: 'humor' },
    { categoryName: 'JUVENILE', category: 'juvenile' },
    { categoryName: 'LANGUAGE ARTS & DISCIPLINES', category: 'language+arts+disciplines' },
    { categoryName: 'LAW', category: 'law' },
    { categoryName: 'LITERARY COLLECTIONS', category: 'literary+collections' },
    { categoryName: 'LITERARY CRITICISM', category: 'literary+criticism' },
    { categoryName: 'MATHEMATICS', category: 'mathematics' },
    { categoryName: 'MEDICAL', category: 'medical' },
    { categoryName: 'MUSIC', category: 'music' },
    { categoryName: 'NATURE', category: 'nature' },
    { categoryName: 'PERFORMING ARTS', category: 'performing+arts' },
    { categoryName: 'PETS', category: 'pets' },
    { categoryName: 'PHILOSOPHY', category: 'philosophy' },
    { categoryName: 'PHOTOGRAPHY', category: 'photography' },
    { categoryName: 'POETRY', category: 'poetry' },
    { categoryName: 'POLITICAL SCIENCE', category: 'political+science' },
    { categoryName: 'PSYCHOLOGY', category: 'psychology' },
    { categoryName: 'REFERENCE', category: 'reference' },
    { categoryName: 'RELIGION', category: 'religion' },
    { categoryName: 'SCIENCE', category: 'science' },
    { categoryName: 'SELF-HELP', category: 'self+help' },
    { categoryName: 'SOCIAL SCIENCE', category: 'social+science' },
    { categoryName: 'SPORTS & RECREATION', category: 'sport+recreation' },
    { categoryName: 'STUDY AIDS', category: 'study+aids' },
    { categoryName: 'TECHNOLOGY & ENGINEERING', category: 'technology+engineering' },
    { categoryName: 'TRANSPORTATION', category: 'transportation' },
    { categoryName: 'TRAVEL', category: 'travel' },
];
